import React, { Component } from 'react'

import {
    Spinner,
    css,
    DataTable,
    DataBody,
    DataRow,
    DataHeader,
    DataCell,
    Select,
    Grid,
    GridCell,
    Checkbox,
} from "@bdfx/mergado-ui-kit"

import { superadminGetMergadoElements, getMergadoElements } from 'app/helpers/api';
import { AxiosResponse } from "axios";

interface Props {
    selectedProjectId: number
}

interface State {
    elements: string[]
    mergadoElements: object
    isLoading: boolean
    filters: string[]
    showHidden: boolean
}

type MergadoElementsType = {
    id: number
    is_attribute: boolean
    hidden: boolean
    origin: string
    children?: any
}

class MergadoElements extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            elements: null,
            mergadoElements: null,
            isLoading: false,
            filters: [],
            showHidden: true
        }
    }

    componentDidMount() {
        this.setState({ isLoading: true })
        superadminGetMergadoElements(this.props.selectedProjectId)
            .then((response: AxiosResponse<any>) => {
                this.setState({
                    mergadoElements: response.data.from_mergado,
                    elements: response.data.elements
                })
            })
            .catch(e => console.error('cannot get mergado elements', e.response))
            .finally(() => {
                this.setState({ isLoading: false })
            })
    }


    render() {
        const { isLoading, mergadoElements, elements, filters, showHidden } = this.state

        if (isLoading) {
            return <div>Getting MergadoElements info <Spinner type={'bubbles'} /></div>
        }

        const originOptions = ['input', 'manual', 'from_rule'].map((o: string) => {
            return {
                label: o,
                value: o,
            }
        })

        const filtersArray = filters ? filters : []

        return (
            <Grid cols={'1fr 1fr'}>
                <GridCell>
                    <ul>{elements && elements.map((elementName: string) => <li key={`element_o_${elementName}`}>{elementName}</li>)}</ul>
                </GridCell>

                <GridCell>
                    <StyledGrid cols="repeat(auto-fit, minmax(100px, 1fr))" gap={"5px"}>
                        <GridCell>
                            <Select
                                options={originOptions}
                                value={filters}
                                label={'filter origin'}
                                multiple={true}
                                closeOnChange={true}
                                onClear={() => this.setState({ filters: [] })}
                                onChange={(e) => this.setState({ filters: e })}
                            />
                        </GridCell>
                        <GridCell>
                            <Checkbox
                                value={showHidden}
                                label={'show hidden'}
                                onChange={(e) => this.setState({ showHidden: e })}
                            />
                        </GridCell>
                    </StyledGrid>

                    <DataTable>
                        <DataHeader>
                            <DataCell type={"header"} className='centered' width={'10%'}>element name</DataCell>
                            <DataCell type={"header"} className='centered'>children</DataCell>
                            <DataCell type={"header"} className='centered' width={'10%'}>origin</DataCell>
                            <DataCell type={"header"} className='centered' width={'10%'}>hidden</DataCell>
                            <DataCell type={"header"} className='centered' width={'10%'}>is_attribute</DataCell>
                            <DataCell type={"header"} className='centered' width={'10%'}>id</DataCell>
                        </DataHeader>
                        <DataBody>
                            {mergadoElements && Object.keys(mergadoElements).map((elementName: string) => {
                                const mergadoElement = mergadoElements[elementName] as MergadoElementsType
                                if ((!filtersArray || filtersArray.length === 0 || filtersArray.includes(mergadoElement.origin)) && (showHidden || !mergadoElement.hidden)) {
                                    return <DataRow key={`element_${elementName}`}>
                                        <DataCell>{elementName}</DataCell>
                                        <DataCell>{mergadoElement.children ? <StyledCode><code>{JSON.stringify(mergadoElement.children, null, "  ")}</code></StyledCode> : ''}</DataCell>
                                        <DataCell>{mergadoElement.origin}</DataCell>
                                        <DataCell>{mergadoElement.hidden ? 'true' : ''}</DataCell>
                                        <DataCell>{mergadoElement.is_attribute ? 'true' : ''}</DataCell>
                                        <DataCell>{mergadoElement.id}</DataCell>
                                    </DataRow>
                                }
                            })}
                        </DataBody>
                    </DataTable>
                </GridCell>
            </Grid>
        )
    }
}


const StyledCode = css('pre')({
    background: '#eeeeee',
    borderRadius: '8px',
    border: '1px solid #dddddd',
    overflow: 'auto',
    fontSize: '6px',
    code: {
        background: '#f6f6f6',
    }
})

const StyledGrid = css(Grid)({
    ' .muk-gridcell': {
        alignSelf: 'center',
    }
})
export default MergadoElements